<template>
  <div class="ttfx-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="content">
        <div class="search-box box">
          <time-search ref="timeSearch" :control="{data:timeType}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick"></time-search>
        </div>
        <div class="grid-content">
          <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
          <div class="echarts-wrap">
            <nk-chart-pre :data="chartData" :timeTitle="timeTitle" :title="chartstitle" class="box-magin" :unit="unit"></nk-chart-pre>
          </div>
          <div class="table-wrap" ref="table-wrap">
            <div class="table-main">
              <el-table ref="ctTableData" size="small" :data="tableData" header-align="center" border :height="tableHeight" highlight-current-row :header-cell-style="tableHeaderColor">
                <el-table-column prop="throwOut" label="投退" align="center" width="100">
                  <template slot-scope="scope" v-if="scope.row.show != false ">
                    <el-checkbox v-model="scope.row.throwOut" @change="toselect(scope.row)"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column prop="displayName" label="变压器" align="center"></el-table-column>
                <el-table-column prop="DeclareCapacity" label="容量(kVA)" align="center"></el-table-column>
                <el-table-column prop="monthLoss" label="月损耗(铁损kWh)" align="center"></el-table-column>
                <el-table-column prop="maxPayLoadVal" label="剩余最大负载(kW)" align="center"></el-table-column>
                <el-table-column prop="maxPayLoadDate" label="剩余最大负载发生时间" align="center"></el-table-column>
                <el-table-column prop="minPayLoadVal" label="剩余最小负载(kW)" align="center"></el-table-column>
                <el-table-column prop="minPayLoadDate" label="剩余最小负载发生时间" align="center"></el-table-column>
              </el-table>
            </div>
            <div class="tabBox" ref="tabBox">
              <div class="tabBlock yellow">
                <div class="tabTop">节省电量<span>(铁损kWh)</span></div>
                <div class="tabBottom">
                  <countTo :startVal="0" :decimals="2" :endVal="parseFloat(tabData.saveEnergy)" :duration="2000"></countTo>
                </div>
              </div>
              <div class="tabBlock cyan">
                <div class="tabTop">实际基本电费<span>(元)</span></div>
                <div class="tabBottom">
                  <countTo :startVal="0" :decimals="2" :endVal="parseFloat(tabData.actualTotalCharge)" :duration="1000"></countTo>
                </div>
              </div>
              <div class="tabBlock pink">
                <div class="tabTop">调整后基本电费<span>(元)</span></div>
                <div class="tabBottom">
                  <countTo :startVal="0" :decimals="2" :endVal="parseFloat(tabData.afterTotalCharge)" :duration="1000"></countTo>
                </div>
              </div>
              <div class="tabBlock blue">
                <div class="tabTop">节省电费(元)</div>
                <div class="tabBottom">
                  <countTo :startVal="0" :decimals="2" :endVal="parseFloat(tabData.saveCharge)" :duration="1000"></countTo>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import uuidv1 from "uuid/v1";
import TabTree from "@/components/common/TabTree.vue";
import { findDataByParam } from "@/utils/index.js";
import TimeSearch from "@/components/common/TimeSearch.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import echarts from "echarts";
import dateTool from "@/utils/dateTool.js";
import NkChartPre from "@/components/page/power/NkChartPre";
import countTo from "vue-count-to";
import ResizeContainer from "@/components/common/resizeContainer.vue";
export default {
  components: {
    TabTree, TimeSearch, BtnShow, NkChartPre, countTo, ResizeContainer
  },
  data () {
    return {
      tabShow: true,//左边的树是否显示
      viewTreeData: [],//树数据
      selectedMeasure: {//当前选中的树数据
        measureId: "",
        measureName: "",
      },
      timeElem: {},//当前的时间参数
      timeType: [
        { type: "month", label: "月" }
      ],
      chartData: [{
        data: [],
        xData: [],
        color: ["#BED2FD", "#BFEEDA", "#BFC5D3", "#FAE5A2"],
        tip: [],
        title: "变压器负载曲线图"
      }],
      unit: "kW",
      timeTitle: "",
      chartstitle: '',
      tableData: [],
      tableHeight: 0,
      tabData: {
        saveEnergy: "",
        actualTotalCharge: "",
        afterTotalCharge: "",
        saveCharge: ""
      },
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setTableHeight();//动态设置表格高度
      window.addEventListener('resize', () => {
        this.setTableHeight();//动态设置表格高度
      });
    })
  },
  methods: {
    async changeCompany (companyId) {//获取树数据
      let res = await this.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, "/power/ttfx", null);
      this.viewTreeData = findDataByParam("viewTree", true, res.data);//数据赋值
    },
    setTableHeight () {
      let tableMain = this.$refs["table-wrap"].offsetHeight - 20;//减去padding的值
      let tabBox = this.$refs["tabBox"].offsetHeight + 10;//加上margin的值
      this.tableHeight = tableMain - tabBox;
    },
    async getData () {
      this.tableData = []
      let res = await this.$api.power.getTransformerInOut(JSON.stringify(this.selectedMeasure.measures), '2', this.timeElem.startTime, this.timeElem.endTime);
      let resData = res.data;
      let chartData = [{
        data: [],
        xData: [],
        color: ["#FAE5A2", "#BFC5D3", "#BFEEDA", "#BED2FD"],
        tip: [],
        title: "变压器负载曲线图",
        zbData: []
      }]
      let data = [];
      let echartData = [];//柱状图数据
      //拿x轴的值
      for (let i in resData.daysApparents) {
        echartData.push(resData.daysApparents[i]);
        chartData[0].xData.push(i);
      }
      //拿图例的值
      for (let j = 0; j < echartData[0].length; j++) {
        data.push({
          param: [],
          zb: [],
          id: echartData[0][j].meterId
        })
        chartData[0].tip.push(echartData[0][j].displayName)
      }
      for (let i = 0; i < echartData.length; i++) {
        for (let j = 0; j < echartData[i].length; j++) {
          if (data[j].id == echartData[i][j].meterId) {
            if (echartData[i][j].apparent != '') {
              echartData[i][j].apparent = parseFloat(echartData[i][j].apparent).toFixed(2)
            }
            // data[j].param.push((echartData[i][j].apparent+' '+echartData[i][j].apparentRatio))
            data[j].param.push((echartData[i][j].apparent))
            data[j].zb.push((echartData[i][j].apparentRatio))
          }
        }
      }
      //那柱状图的数据
      for (let i = 0; i < data.length; i++) {
        chartData[0].data.push(data[i].param)
        chartData[0].zbData.push(data[i].zb)
      }
      //颠倒负载值
      for (let i = 0; i < chartData[0].data.length / 2; i++) {
        let temp = chartData[0].data[i]
        chartData[0].data[i] = chartData[0].data[chartData[0].data.length - 1 - i]
        chartData[0].data[chartData[0].data.length - 1 - i] = temp

      }
      //颠倒负载率
      for (let i = 0; i < chartData[0].zbData.length / 2; i++) {
        let temp = chartData[0].zbData[i]
        chartData[0].zbData[i] = chartData[0].zbData[chartData[0].zbData.length - 1 - i]
        chartData[0].zbData[chartData[0].zbData.length - 1 - i] = temp

      }
      chartData[0].tip = chartData[0].tip.reverse()
      this.chartData = chartData
      resData.transformersMinMaxPayLoad[resData.transformersMinMaxPayLoad.length - 1]["show"] = false
      for (let i = 0; i < resData.transformersMinMaxPayLoad.length; i++) {
        let item = resData.transformersMinMaxPayLoad[i]
        //当DeclareCapacity="--"时，isNaN(Number(item.DeclareCapacity))为true
        item.DeclareCapacity = item.DeclareCapacity == '' ? '' : Number(item.DeclareCapacity).toFixed(2)
        item.maxPayLoadVal = item.maxPayLoadVal == '' ? '' : Number(item.maxPayLoadVal).toFixed(2)
        item.minPayLoadVal = item.minPayLoadVal == '' ? '' : Number(item.minPayLoadVal).toFixed(2)
        item.monthLoss = item.monthLoss == '' ? '' : Number(item.monthLoss).toFixed(2)
        if (isNaN(Number(item.DeclareCapacity))) {
          item.DeclareCapacity = '--'
        }
        if (isNaN(Number(item.monthLoss))) {
          item.monthLoss = '--'
        }
      }
      this.tableData = resData.transformersMinMaxPayLoad;
      this.tabData = resData.totalCharges;
    },
    tabTreeDefault (e) {//首次加载树时执行，保留默认的树选择
      this.selectedMeasure.measures = this.findBottom(e, []);
      this.getData();//获取数据
    },
    /* 遍历拿取最低级子节点 */
    findBottom (data, measures) {
      let vm = this
      if (data.children.length == 0 || !data.children) {
        measures.push(data.measureId)
      } else {
        for (let i = 0; i < data.children.length; i++) {
          let item = data.children[i]
          vm.findBottom(item, measures)
        }
      }
      return measures;
    },
    tabTreeClick (e) {//树节点点击的时候触发
      this.selectedMeasure.measures = this.findBottom(e, []);
      this.getData();//获取数据
    },
    timeControlChange (e) {//时间下拉框切换时触发
      this.timeElem = e;
    },
    TimeControlClick (e) {//时间点击查询时
      this.timeElem = e;
      this.getData();
    },
    tableHeaderColor ({ row, column, rowIndex, columnIndex }) {//改表头颜色
      if (rowIndex === 0) {
        return "background-color: #dbdbdb;color: #666;";
      }
    },
    toselect (row) {//投退复选框
      let meterIds = [];
      let total = 0;
      let total1 = 0;
      let temp = null;
      this.tableData.forEach(item => {
        if (item.throwOut) {
          meterIds.push(item.meterId)
          total += Number(item.monthLoss);
          total1 += Number(item.DeclareCapacity);
        }
      });
      if (total1 > this.tableData[this.tableData.length - 1].minPayLoadVal) {
        this.$message({
          message: '容量和已超过容量最小差值',
          type: 'warning'
        });
        this.tableData.forEach(item => {
          if (item.meterId == row.meterId) {
            item.throwOut = '';
          }
        });
        return;
      }
      this.tabData.saveEnergy = total;
      if (meterIds.length > 0) {
        this.$api.power.getMonthEnergyToCharge(meterIds, '1', '2', this.timeElem.startTime, this.timeElem.endTime).then(res => {
          this.tabData.saveCharge = res.data.charge == '' ? 0 : res.data.charge;
          this.tabData.afterTotalCharge = Number(this.tabData.actualTotalCharge) - Number(this.tabData.saveCharge);
        })
      } else {
        this.tabData.saveCharge = 0;
        this.tabData.afterTotalCharge = Number(this.tabData.actualTotalCharge) - Number(this.tabData.saveCharge);
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.ttfx-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  padding: 23px;
  box-sizing: border-box;
  .tree-content {
    width: 100%;
    margin-right: 14px;
  }
  .content {
    position: relative;
    width: 100%;
    height: 100%;
    .search-box {
      height: 36px;
      .option {
        width: 150px;
        margin: 0 0 0 10px;
      }
    }
    .grid-content {
      position: absolute;
      top: 50px;
      width: 100%;
      bottom: 0;
      display: flex;
      flex-flow: column;
      .echarts-wrap {
        flex: 2;
        width: 100%;
        background: #fff;
        margin-bottom: 14px;
        border-radius: 4px;
        overflow: hidden;
      }
      .table-wrap {
        flex: 3;
        width: 100%;
        background: #fff;
        border-radius: 4px;
        overflow: hidden;
        padding: 10px;
        box-sizing: border-box;
        .table-main {
          width: 100%;
        }
        .tabBox {
          display: flex;
          margin: 5px 0;
          .tabBlock {
            display: flex;
            flex: 1;
            color: #fff;
            flex-flow: column;
            margin: 0 15px;
            border-radius: 4px;
            align-items: center;
            height: 140px;
            .tabTop {
              display: flex;
              flex: 1;
              font-size: 20px;
              width: 100%;
              justify-content: center;
              padding: 10px 0;
              box-sizing: border-box;
              span {
                font-size: 12px;
                margin-top: 5px;
                margin-left: 5px;
              }
            }
            .tabBottom {
              display: flex;
              flex: 1;
              font-size: 32px;
              font-weight: 600;
              width: 100%;
              justify-content: center;
              padding: 10px 0;
              box-sizing: border-box;
            }
          }
          .yellow {
            background: rgba(254, 182, 72);
          }
          .cyan {
            background: rgba(50, 186, 172);
          }
          .pink {
            background: rgba(239, 71, 123);
          }
          .blue {
            background: rgba(40, 121, 199);
          }
        }
      }
    }
  }
}
</style>